import { render, staticRenderFns } from "./select-institutions.vue?vue&type=template&id=480f4af4"
import script from "./select-institutions.vue?vue&type=script&lang=js"
export * from "./select-institutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports